import { useEffect } from "react";

export const DmcaBadge = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://images.dmca.com/Badges/DMCABadgeHelper.min.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <a
      href="https://www.dmca.com/Protection/Status.aspx?id=bce2bad9-34ec-4d23-81ab-ffb5d1bdf24a&refurl=https://www.iampesmobile.com/"
      title="DMCA.com Protection Status"
      className="dmca-badge"
    >
      <img
        src="https://images.dmca.com/Badges/DMCA_logo-grn-btn100w.png?ID=bce2bad9-34ec-4d23-81ab-ffb5d1bdf24a"
        alt="DMCA.com Protection Status"
      />
    </a>
  );
};
